import Stack from "@mui/material/Stack";

import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import OutlinedInput from "@mui/material/OutlinedInput";

import EpisodeItem from "src/pages/components/DetailModal/EpisodeItem";
import withSeasons from "src/hoc/withSeasons";

function SeasonList({ seasons, selectedSeason, fetchEpisodes }) {
  if (seasons.length > 0) {
    return (
      <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, mt: 2 }}>
        <Stack direction="row" alignItems="center" mb={{ xs: 1, sm: 2 }}>
          {selectedSeason && (
            <Typography variant="h4" gutterBottom>
              {selectedSeason.title} | Episodes
            </Typography>
          )}
          <Box flexGrow={1} />
          {selectedSeason && (
            <Select
              value={selectedSeason.contentId}
              sx={{
                borderRadius: 0,
                border: "2px soild white",
                "& .MuiSelect-select": { py: 1, width: 100 },
              }}
              input={<OutlinedInput />}
              onChange={(e) => {
                // console.log(e);
                fetchEpisodes(
                  seasons.find((i) => i.contentId === e.target.value)
                );
              }}
            >
              {seasons.map((season, idx) => (
                <MenuItem key={idx} value={season.contentId}>
                  {season.title}
                </MenuItem>
              ))}
            </Select>
          )}
        </Stack>
        {selectedSeason && selectedSeason.episodes && (
          <Stack spacing={{ xs: 1, sm: 2 }}>
            {selectedSeason.episodes.map((e, idx) => (
              <EpisodeItem key={idx} episode={e} />
            ))}
          </Stack>
        )}
      </Box>
    );
  } else if (seasons.length === 0) {
    return (
      <Box sx={{ px: { xs: 2, sm: 3, md: 5 }, mt: 2 }}>
        <Stack mb={{ xs: 1, sm: 2 }}>
          <Typography variant="subtitle2">
            This series doesn't have any season yet. Please come back later
          </Typography>
        </Stack>
      </Box>
    );
  }
}

const SeasonListInDetailModal = withSeasons(SeasonList);

export default SeasonListInDetailModal;
